import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import Copyright from '@components/Auth/Copyright';
import { useNavigate } from 'react-router-dom';
import logoCircle from '@assets/img/logoCircle.png';
import logo from '@assets/logos/logo.png';

/**
 * "¿Olvidaste tu PIN?" del login.
 *
 * Hasta el 2026-09-29 esto era un formulario de correo cuyo envío estaba vacío: no
 * mandaba nada y nadie se enteraba. Un correo de recuperación tampoco serviría: el
 * PIN es de 6 dígitos y muchos entran con un correo interno `@staff.krispis.mx` al
 * que no llega nada. Lo que sí funciona es pedírselo a quien lo administra: el admin
 * de su sucursal o el general lo restablece en Usuarios → Editar → "Restablecer PIN".
 */
const ForgotPasswordScreen = () => {
    const navigation = useNavigate();

    return (
        <Grid container component="main" height="100vh">
            <CssBaseline />
            <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Container maxWidth="sm">
                    <Stack spacing={4}>
                        <Box component="img" alignSelf="center" src={logo} height={80} />
                        <Stack spacing={1.5} textAlign="center">
                            <Typography variant="h6" fontWeight={600}>
                                ¿Olvidaste tu PIN?
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Pídele al administrador de tu sucursal (o al administrador general) que te lo
                                restablezca. Lo hace en Usuarios, y te dice el PIN nuevo en persona.
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Tu correo para entrar sigue siendo el mismo. Después puedes cambiar el PIN en Mi perfil.
                            </Typography>
                        </Stack>
                        <Button fullWidth variant="contained" color="primary" size="large" onClick={() => navigation('/')}>
                            Regresar al login
                        </Button>
                        <Copyright />
                    </Stack>
                </Container>
            </Grid>
            <Grid item xs={0} md={6} bgcolor="black">
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                    <Box component="img" src={logoCircle} width="50%" />
                </Box>
            </Grid>
        </Grid>
    );
};
export default ForgotPasswordScreen;
